<!-- Attributations footer -->
<div class="footer-container d-flex jc-around ai-center fd-col--sm gap-16--sm">
  <div class="d-flex jc-center ai-center gap-16 fd-col--xs">
    <span class="print-text text-center--xs"
      >© {{ currentYear }} - Simmons-Boardman Publishing Corporation.</span
    >
    <!-- <span>
      Powered by
      <a class="suvo-text"><b>informally</b></a>
    </span> -->
  </div>
  <div class="d-flex jc-center ai-center gap-16 fd-col--xs">
    <a class="footer-link" mat-button href="https://irjpro-help.suvotechnology.com" target="_blank"
      >Help</a
    >
    <a class="footer-link" mat-button href="/privacy-policy" target="_blank">Privacy policy</a>
    <a class="footer-link" mat-button href="/terms-and-conditions" target="_blank"
      >Terms & conditions</a
    >
  </div>
</div>
